import { faExternalLink } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as CreateCampaignDialog from 'components/create-campaign-dialog';
import * as RequiredItem from 'components/required-checklist/required-items/RequiredItem';
import { useChecklistData } from 'components/required-checklist/useChecklistData';
import { CAMPAIGN_HELP_CREATE_LINK } from 'constants/links';
import { posthogEvents } from 'constants/posthog-events';
import { usePosthog } from 'customHooks/usePosthog';

const RequiredCreateCampaign = () => {
    const { pushEvent } = usePosthog();
    const { checklist } = useChecklistData();
    const { createCampaign } = checklist;
    return (
        <RequiredItem.Root>
            <RequiredItem.TextContent className="gap-6 sm:gap-0">
                <div className="flex w-full flex-col items-start gap-3">
                    <RequiredItem.RequiredItemDuration>5 min</RequiredItem.RequiredItemDuration>
                    <div>
                        <RequiredItem.Title>Create a campaign</RequiredItem.Title>
                        <RequiredItem.Description>
                            Build your first fundraiser in minutes—whether it’s a donation form,
                            fundraising page, or event. Add your story, goal, and photos to get
                            ready to go live.
                        </RequiredItem.Description>
                    </div>
                </div>
                {createCampaign ? (
                    <RequiredItem.CompletedIndicator />
                ) : (
                    <div className="flex gap-2">
                        <CreateCampaignDialog.Root
                            triggerLocation={
                                CreateCampaignDialog.TriggerLocation.RequiredChecklistDashboard
                            }
                        >
                            <CreateCampaignDialog.Trigger asChild>
                                <RequiredItem.PrimaryButton
                                    onClick={() =>
                                        pushEvent(posthogEvents.DASHBOARD_CHECKLIST_ITEM_SELECTED, {
                                            checklistItem: 'createCampaign',
                                        })
                                    }
                                >
                                    Create campaign
                                </RequiredItem.PrimaryButton>
                            </CreateCampaignDialog.Trigger>
                        </CreateCampaignDialog.Root>
                        <RequiredItem.SecondaryButton
                            onClick={() => window.open(CAMPAIGN_HELP_CREATE_LINK, '_blank')}
                        >
                            Learn more <FontAwesomeIcon icon={faExternalLink} />
                        </RequiredItem.SecondaryButton>
                    </div>
                )}
            </RequiredItem.TextContent>
            <RequiredItem.Image
                desktopSrc="/images/graphics/homepage-checklist/createCampaignDesktop.png"
                mobileSrc="/images/graphics/homepage-checklist/createCampaignMobile.png"
            />
        </RequiredItem.Root>
    );
};

export { RequiredCreateCampaign };
